<template lang="pug">
  div.patient-info-wrapper
    div.patient-info
      span {{currentSchedule.patient.med_record_number}}
        small {{currentSchedule.patient.name}}
      span(v-if="currentSchedule.bed") 病床：{{currentSchedule.bed.code}}
    div.gender-img
      img(src="static/svg/masculine.svg" v-if="currentSchedule.patient.gender === 'male'")
      img(src="static/svg/femenine.svg" v-if="currentSchedule.patient.gender === 'female'")
      span(v-if="currentSchedule.patient.gender === null") 性別未定義
    //div.print-button(@click="printQR")
    //  img(src="static/svg/printer.svg")
    //  span 列印條碼
      

</template>

<script>
export default {
  name: 'PatientInfo',
  computed: {
    currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
  },
  methods: {
    printQR() {
      this.$store.dispatch('printQR');
    },
  },
};
</script>

<style lang="sass">
.patient-info-wrapper
  border: 1px solid black
  background-color: white
  margin: 16px 0
  width: 225px
  border-radius: 5px
  display: flex
  .gender-img
    width: 20%
    display: flex
    justify-content: center
    align-items: center
    span
      font-size: 12px
    img
      width: 80%
  .patient-info
    padding-left: 10px
    display: flex
    justify-content: center
    flex-direction: column
    width: 75%
    small
      padding-left: 5px    
  //.print-button
  //  background-color: gray 
  //  padding: 10px
  //  width: 25%
  //  display: flex
  //  flex-direction: column
  //  align-items: center
  //  justify-content: center
  //  span
  //    color: white
  //    font-size: 12px
  //  img
  //    width: 40%

</style>



// WEBPACK FOOTER //
// PatientInfo.vue?453d8828